import { render, staticRenderFns } from "./PhotoPanel.vue?vue&type=template&id=0ff44213&scoped=true"
import script from "./PhotoPanel.vue?vue&type=script&lang=js"
export * from "./PhotoPanel.vue?vue&type=script&lang=js"
import style0 from "./PhotoPanel.vue?vue&type=style&index=0&id=0ff44213&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff44213",
  null
  
)

export default component.exports